import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'wouter';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookieConsent')) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gothic-charcoal border-t border-gothic-gray px-6 py-4 flex items-center justify-between gap-4 flex-wrap">
      <p className="text-sm text-gray-400">
        This site uses cookies to improve your experience.{' '}
        <Link href="/privacy" className="underline hover:text-gothic-white transition-colors">
          Privacy Policy
        </Link>
      </p>
      <Button size="sm" onClick={accept} className="bg-blood-red hover:bg-red-700">
        Accept
      </Button>
    </div>
  );
}
